/**
 * SubscribeGameIncidentsQueryInfo defines properties and callbacks for the subscribe of gameIncidents endpoint of the sports data client.
 * @class SportDataGatewayQueryInfo
 */
export class SubscribeGameIncidentsQueryInfo {
    /* istanbul ignore next */
    constructor(eventIds, onMessageHandler, onErrorHandler, incidentTypes) {
        this.onMessageHandler = onMessageHandler;
        this.onErrorHandler = onErrorHandler;
        this.eventIds = eventIds;
        this.incidentTypes = incidentTypes;
    }
}
//# sourceMappingURL=SubscribeGameIncidentsQueryInfo.js.map